import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import clsx from 'clsx';
import path from 'path';
import url from 'url';
import { selectFromConfig } from '@gandi/redux-config';
import { localeSelector } from '@gandi/translate';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import Main from '../components/Main';
import { ErrorBoundary } from './ErrorBoundary';
import { layout } from '../modules/layout';
var styles = {
  "root": "Layout-root_3O2WH",
  "header": "Layout-header_2KVXC",
  "navigation": "Layout-navigation_7qgD8",
  "main": "Layout-main_38-ac",
  "footer": "Layout-footer_23kI7",
  "is-collapsed": "Layout-is-collapsed_1yMBq",
  "is-expanded": "Layout-is-expanded_2HWWf"
};
var selectPublicUrl = selectFromConfig('app.layout.urls.public_site', 'https://www.gandi.net');
var selectAdminUrl = selectFromConfig('app.layout.urls.admin', 'https://admin.gandi.net');
var selectLocalePublicUrl = createSelector(selectPublicUrl, localeSelector, function (publicUrl, locale) {
  return url.resolve(publicUrl, path.join(locale));
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    isNavigationExpanded: layout.selectors.selectIsNavigationExpanded(state),
    publicUrl: selectLocalePublicUrl(state),
    adminUrl: selectAdminUrl(state)
  };
};

// Not much value to type the action here.
// flowlint-next-line unclear-type: off
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  if (typeof ownProps.toggleNavigation === 'function') {
    return {
      toggleNavigation: ownProps.toggleNavigation
    };
  }
  return bindActionCreators({
    toggleNavigation: layout.actions.toggleNavigation
  }, dispatch);
};
function Layout(_ref) {
  var isNavigationExpanded = _ref.isNavigationExpanded,
    toggleNavigation = _ref.toggleNavigation,
    isAuthenticated = _ref.isAuthenticated,
    navigationItems = _ref.navigationItems,
    navigationLocales = _ref.navigationLocales,
    onLocaleChange = _ref.onLocaleChange,
    currentLocale = _ref.currentLocale,
    onLinkClick = _ref.onLinkClick,
    headerWidgets = _ref.headerWidgets,
    footerContent = _ref.footerContent,
    _ref$mainWrapper = _ref.mainWrapper,
    mainWrapper = _ref$mainWrapper === void 0 ? true : _ref$mainWrapper,
    adminUrl = _ref.adminUrl,
    publicUrl = _ref.publicUrl,
    className = _ref.className,
    children = _ref.children;
  var rootClasses = clsx(styles.root, isNavigationExpanded ? styles['is-expanded'] : styles['is-collapsed'], className);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClasses
  }, /*#__PURE__*/React.createElement(Header, {
    isNavigationExpanded: isNavigationExpanded,
    toggleNavigation: toggleNavigation,
    className: styles.header,
    hrefLogo: isAuthenticated ? adminUrl : publicUrl
  }, headerWidgets), /*#__PURE__*/React.createElement(Navigation, {
    items: navigationItems,
    onLinkClick: onLinkClick,
    isAuthenticated: isAuthenticated,
    locales: navigationLocales,
    currentLocale: currentLocale,
    onLocaleChange: onLocaleChange,
    className: styles.navigation
  }), /*#__PURE__*/React.createElement(ErrorBoundary, null, mainWrapper ? /*#__PURE__*/React.createElement(Main, {
    className: styles.main
  }, children) : children), footerContent ? /*#__PURE__*/React.createElement(Footer, {
    className: styles.footer
  }, footerContent) : null);
}
export default connect(mapStateToProps, mapDispatchToProps)(Layout);